import HeroRenters from 'shared/lib/assets/img/landing/hero-renters.png';
import LogoAssurant from 'shared/lib/assets/img/logo/logo-assurant.svg';

export const rentersConfig = {
  hero: {
    heading: 'Safe at Home: Renter’s Insurance',
    subheading:
      'So simple, it’s brilliant: Tell us about you, where you live, and what you have, and we’ll get you the best policy to protect your stuff.',
    cta: 'Get renters insurance',
    ctaLink: '/renters-insurance/start',
    img: HeroRenters,
  },
  underwriter: {
    img: LogoAssurant,
    name: 'Assurant',
  },
  coverageDetails: [
    {
      heading: 'Personal Property',
      subheading:
        'Coverage for your belongings if they are damaged anywhere in the world.',
    },
    {
      heading: 'Loss of Use',
      subheading:
        'In the event that your property becomes unlivable, costs relating to housing and increased living expenses will be covered.',
    },
    {
      heading: 'Personal Liability',
      subheading:
        'Protection in the event of bodily injury or damage to someone else’s property for which you are legally liable. There’s no deductible for this coverage.',
    },
    {
      heading: 'Replacement Costs',
      subheading:
        'If your personal property is damaged by a covered peril, we will pay to replace the item without deduction for depreciation since it was purchased.',
    },
    {
      heading: 'Sewage or Drain Backup',
      subheading:
        'Coverage for your personal property damaged as the result of a water backup of sewers or drains.',
    },
    {
      heading: 'Identity Fraud',
      subheading:
        'Identity Fraud Expense Coverage is an endorsement to the Renters Insurance Program that helps cover the cost and time it takes to restore your identity.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Renters Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'A visitor trips over a toy left in a stairwell, resulting in a hospital stay.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'What was meant to be a simple dinner party, turns to disaster with a fire that starts in the oven and leads to damage to the building.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'Your upstairs neighbor plans a relaxing bath, but forgets and overflows the tub. Now water is flooding into your unit causing damage.',
      },
      {
        heading: 'Scenario 4',
        subheading:
          'You return from a trip and discover you’ve been burgled—and some prized possessions are missing.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
